<template>
  <div class="main">
      <div class="overlay-mensa" v-show="showPopup" v-on:click="showPopup=false">
        <div class="overlay-popup" v-show="showPopup">
          <img class="img_chef" src="../assets/images/mensa/icona_chef.svg">
          <div class="popup_text">
            <span class="popup_title">Scegli e prenota il tuo<br>pranzo con Life!</span>
            <span class="popup_text_detail">Le prenotazoni nei giorni feriali sono valide solo se effettuate il giorno precedente al pasto ordinato.<br>
              Per il pasto del lunedì l'ordine va fatto il venerdì entro le 18:00<br><br>
              Dopo aver consumato il pasto ricordati di
              <span style="color:#3890ce;">LASCIARE IN ORDINE.</span><br><br>
            Grazie della collaborazione!</span>
          </div>
        </div>
      </div>
    <div v-bind:class="[orderClasses]" id="mensa-box" v-if="!!!order">
      <div id="categorie-mensa">
        <div id="scrolling-section">
          <div
            v-for="category in allCategories"
            v-bind:key="category.name"
            class="categoria-box"
            v-on:tap="toggleCategoryFilter(category)"
            v-bind:class="{ selected: categoryFilter.indexOf(category.name)!=-1 }"
          >
            <div class="category-img">
              <img v-bind:src="category.mainIcon" />
            </div>
            <h4 class="category-label">{{category.label}}</h4>
          </div>
        </div>
      </div>
      <div id="lista-piatti">
        <DishesList
          v-bind:orderCategories="orderCategories"
          v-bind:category="category"
          v-for="category in categories"
          v-bind:key="category.name"
          v-bind:dishes="getDishesByCategory(category)"
        ></DishesList>
      </div>
      <div v-on:tap="createOrder()" class="button clickable">Prenota</div>
    </div>
    <MensaOrder
      v-on:confirmOrder="sendOrder"
      v-on:orderDeleted="deleteOrder"
      v-bind:categories="allCategories"
      v-bind:order="order"
      v-else
    ></MensaOrder>
  </div>
</template>
<script>
import DishesList from '../components/DishesList';
import store from '../stores';
import enums from '../enums/RdsLife.enums';
import config from '../config';
import RestStore from '../stores/RestStore';
import userService from '../services/User.service';
import MensaOrder from '../components/MensaOrder';
import { eventBus } from '../services/EventBus';
const restStore = new RestStore();
export default {
  name: 'dish',
  components: { DishesList, MensaOrder },
  data() {
    return {
      dishes: [],
      categoryFilter: [],
      order: null,
      showPopup: true
    };
  },
  methods: {
    getDishesByCategory: function(category) {
      var dishes = this.dishes;
      return dishes.filter(d => d.categoria.name === category.name);
    },
    deleteOrder() {
      restStore.remove('order', this.order).then(o => {
        console.log(o);
        this.order = null;
      });
    },
    toggleCategoryFilter: function(category) {
      let idx = this.categoryFilter.indexOf(category.name);
      if (idx !== -1) {
        this.categoryFilter.splice(idx, 1);
      } else {
        this.categoryFilter = [category.name];
      }
    },
    createOrder() {
      const today = new Date();
      today.setMilliseconds(0);
      today.setSeconds(0);
      today.setMinutes(0);
      today.setHours(0);

      const ordererDishes = this.dishes.filter(d => d.orderQuantity > 0);
      console.log(ordererDishes);
      const order = {
        id: userService.user.id + '_' + today.getTime(),
        user: { id: userService.user.id, name: userService.user.name },
        dishes: ordererDishes,
        confirmed: false,
        ready: false
      };

      this.order = order;
      eventBus.$emit('showBackButton');
    },
    backButtonClicked() {
      if (this.order && !this.order.confirmed) {
        this.order = null;
      }
      eventBus.$emit('hideBackButton');
    },
    sendOrder(order) {
      let orderCopy = Object.assign({}, order);

      orderCopy.dishes = orderCopy.dishes.map(d => {
        return { id: d.id };
      });
      _saveOrder(orderCopy).then(data => {
        console.log('save', data);
        const order = _awsObjToModel(data.data);
        this.order = _enrichOrder(order, this.dishes);
      });
    }
  },
  computed: {
    categories: function() {
      return getCategories(this.dishes, this.categoryFilter);
    },
    allCategories: function() {
      return config.dishCategories;
    },
    ordererDishes() {
      return this.dishes.filter(d => d.orderQuantity > 0);
    },
    orderCategories() {
      return this.ordererDishes.map(d => d.categoria.name);
    },
    mainDishOrdered() {
      const mainCategories = ['primi', 'secondi', 'piatti freddi'];
      return this.ordererDishes.filter(
        d => mainCategories.indexOf(d.categoria.name) !== -1
      ).length;
    },
    sideDishOrdered() {
      const sideDishCategories = ['contorni', 'panini'];
      return this.ordererDishes.filter(
        d => sideDishCategories.indexOf(d.categoria.name) !== -1
      ).length;
    },
    fruitOrdered() {
      const fruitCategories = ['frutta'];
      return this.ordererDishes.filter(
        d => fruitCategories.indexOf(d.categoria.name) !== -1
      ).length;
    },
    orderClasses() {
      let cssClasses = [];
      if (this.mainDishOrdered) {
        cssClasses.push('mainDishOrdered');
      }
      if (this.sideDishOrdered) {
        cssClasses.push('sideDishOrdered');
      }
      if (this.fruitOrdered) {
        cssClasses.push('fruitOrdered');
      }
      return cssClasses;
    }
  },
  mounted() {
    eventBus.$emit('updating');
    const today = new Date();
    today.setMilliseconds(0);
    today.setSeconds(0);
    today.setMinutes(0);
    today.setHours(0);

    restStore
      .get('menu', today.getTime())
      .then(response => response.json())
      .then(response => response.data.Items)
      .then(data => data.filter(d => d.visibility === 'public'))
      .then(data => data.map(_awsObjToModel))
      .then(menus => {
        const menu = menus[0];
        console.log(menu);
        getDishes().then(dishes => {
          restStore
            .get('order', userService.user.id + '_' + today.getTime())
            .then(response => response.json())
            .then(response => response.data.Items)
            .then(data => data.filter(d => d.visibility === 'public'))
            .then(data => data.map(_awsObjToModel))
            .then(orders => {
              if (orders.length > 0) {
                this.order = _enrichOrder(orders[0], dishes);
              }
            });
          console.log(dishes);
          let menuDishes = [];
          if (!!menu) {
            for (let i = 0; i < menu.dishes.length; i++) {
              const menuDish = dishes.find(d => d.id === menu.dishes[i].id);
              if (!!menuDish) {
                menuDish.quantity = menu.dishes[i].quantity;
                menuDish.orderQuantity = 0;
                menuDishes.push(menuDish);
              }
            }
            this.dishes = menuDishes;
          }

          setTimeout(() => {
            eventBus.$emit('updated');
          }, 300);
        });
      });
  },
  created() {
    eventBus.$on('backButtonClicked', () => {
      console.log('MENSA backButtonClicked');
      this.backButtonClicked();
    });
  }
};

function getDishes() {
  console.log('getDishes');
  return store.getAll(enums.modelTypes.DISH);
}

function getCategories(dishes, categoryFilter) {
  if (categoryFilter && categoryFilter.length) {
    return (
      config.dishCategories
        // .map(d => d.categoria)
        .filter(c => categoryFilter.indexOf(c.name) !== -1)
        .filter((el, idx, arr) => arr.map(c => c.name).indexOf(el.name) === idx)
    );
  }
  return config.dishCategories;
}

function _saveOrder(order) {
  return restStore.add('order', order);
}
function _awsObjToModel(i) {
  let content = i.content;
  content.id = isNaN(Number(i.id)) ? i.id : Number(i.id);
  return content;
}
function _enrichOrder(order, dishes) {
  const orderDishes = [];
  for (let i = 0; i < order.dishes.length; i++) {
    const element = order.dishes[i];
    const dish = dishes.find(d => d.id === element.id);
    orderDishes.push(dish);
  }
  order.dishes = orderDishes;
  return order;
}
</script>
<style lang="scss" scoped>
.selected {
  border: #ef8116 1px solid;
}
#scrolling-section {
  display: flex;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding: 30px 0;
  .categoria-box {
    display: flex;
    background-color: #ffffff;
    margin-left: 14px;
    align-items: center;
    white-space: pre;
    // padding: 24px 0;
    // width: 132px;
    // min-width: 132px;
    // min-width: 175px;
    border-radius: $default-border-radius;
    padding: 15px 0;
    &:nth-child(1) {
      margin-left: 20px;
    }
    @include shadow-bottom;
    .category-img {
      width: 36px;
      height: 36px;

      max-width: 36px;
      min-width: 36px;
      margin: auto 10px auto 15px;
      img {
        width: 100%;
      }
    }
    .category-label {
      flex-grow: 1;
      font-size: 1.07em;
      font-weight: 600;
      margin: 0 17px 0 0;
      letter-spacing: 1px;
    }
  }
}
.button {
  background-color: #a31313;
  color: #ffffff;
  margin: 0 20px 30px;
  text-align: center;
  padding: 20px 0;
  border-radius: $default-border-radius;
}
  .overlay-mensa{
    background-color: rgba(255,255,255,.8);
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 2;
  }
  .overlay-popup{
    background-image: url("../assets/images/mensa/background_popup_mensa.svg");
    position: relative;
    width: 80%;
    height: calc(100% - 210px);
    z-index: 3;
    /*max-width: 442px;*/
    background-position: top;
    background-size: contain;
    background-repeat: no-repeat;
    /* left: 10%; */
    /*max-height: 330px;*/
    margin: 50px auto;
    padding-top: 15px;
    padding-left: 15px;
    padding-right: 15px;
  }
  .img_chef{
    display: block;
    margin: 0 auto;
    width: 12%;
    max-width: 50px;
  }
  .popup_text{
    margin: 0 auto;
    max-width: 500px;
    padding-top: 10px;
    text-align: center;
    color: #ffffff;
  }
  .popup_title{
    font-size: 1.07em;
    font-weight: 600;
    letter-spacing: 1px;
    display: block;
    line-height: 1.4;
    margin-bottom: 10px;
  }
  .popup_text_detail{
    font-size: 0.9em;
    font-weight: 300;
    letter-spacing: 1px;
    display: block;
    line-height: 1.4;
    margin-bottom: 10px;
  }
</style>
